"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidI18nFormatters = void 0;
const date_fns_1 = require("date-fns");
const enums_1 = require("../../structs/enums");
const fluid_number_format_options_style_enum_1 = require("../../structs/enums/fluid-number-format-options-style.enum");
const fluid_localisation_lookup_1 = require("./fluid-localisation.lookup");
const currencySpace = ' ';
const defaultLocale = (0, fluid_localisation_lookup_1.getFluidLocale)(enums_1.FluidLocale === null || enums_1.FluidLocale === void 0 ? void 0 : enums_1.FluidLocale.UNITED_STATES);
function formatTime(date, locale) {
    const { timeFormat } = (0, fluid_localisation_lookup_1.getFluidLocale)(locale) || defaultLocale;
    return (0, date_fns_1.format)(date, timeFormat);
}
function formatDate(date, locale) {
    const { dateFormat } = (0, fluid_localisation_lookup_1.getFluidLocale)(locale) || defaultLocale;
    return (0, date_fns_1.format)(date, dateFormat);
}
function formatNumber(number, locale, options) {
    const { localeCode } = (0, fluid_localisation_lookup_1.getFluidLocale)(locale) || defaultLocale;
    const formatOptions = Object.assign({ style: fluid_number_format_options_style_enum_1.FluidNumberFormatOptionsStyle.DECIMAL }, options);
    const formatter = new Intl.NumberFormat(localeCode, formatOptions);
    return formatter.format(number);
}
function formatCurrency(amount, locale, options) {
    const { localeCode, currencyCode } = (0, fluid_localisation_lookup_1.getFluidLocale)(locale) || defaultLocale;
    const formatOptions = {
        style: fluid_number_format_options_style_enum_1.FluidNumberFormatOptionsStyle.CURRENCY,
        currency: currencyCode,
        maximumFractionDigits: (options === null || options === void 0 ? void 0 : options.wholeOnly) ? 0 : (options === null || options === void 0 ? void 0 : options.maximumFractionDigits) || 2,
        minimumFractionDigits: (options === null || options === void 0 ? void 0 : options.wholeOnly) ? 0 : (options === null || options === void 0 ? void 0 : options.minimumFractionDigits) || 2,
    };
    const formatter = new Intl.NumberFormat(localeCode, formatOptions);
    return formatter.format(amount).replace(currencySpace, ' ');
}
exports.FluidI18nFormatters = {
    formatTime,
    formatDate,
    formatNumber,
    formatCurrency
};
